import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQueryExcelExport } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';
import { format, parseISO } from 'date-fns';
import { Company, isRebattery } from 'shared-pages/common/constants';
import { isAfisCyprus } from 'shared-pages/common/constants';
import { isFotokiklosi } from 'shared-pages/common/constants';

export const exportColumns = (t) => {
  return [
    { fieldName: 'id', fieldTitle: t('ID'), fieldType: 'TEXT' },
    { fieldName: 'code', fieldTitle: t('Κωδικός'), fieldType: 'TEXT' },
    { fieldName: 'name', fieldTitle: t('Επωνυμία'), fieldType: 'TEXT' },
    { fieldName: 'addressDescription', fieldTitle: t('Περιγραφή Διεύθυνσης'), fieldType: 'TEXT' },
    { fieldName: 'addressLine1', fieldTitle: t('Διεύθυνση'), fieldType: 'TEXT' },
    { fieldName: 'addressLine2', fieldTitle: t('Διεύθυνση 2'), fieldType: 'TEXT' },
    { fieldName: 'addressArea', fieldTitle: t('Περιοχή'), fieldType: 'TEXT' },
    { fieldName: 'addressCity', fieldTitle: t('Πόλη'), fieldType: 'TEXT' },
    { fieldName: 'postalCode', fieldTitle: t('Τ.Κ.'), fieldType: 'TEXT' },
    { fieldName: 'subregion.name', fieldTitle: t('Περιφερειακή Ενότητα'), fieldType: 'TEXT' },
    { fieldName: 'region.name', fieldTitle: t('Περιφέρεια'), fieldType: 'TEXT' },
    { fieldName: 'phone', fieldTitle: t('Τηλέφωνο'), fieldType: 'TEXT' },
    { fieldName: 'email', fieldTitle: t('Email'), fieldType: 'TEXT' },
    { fieldName: 'companyVat', fieldTitle: t('Α.Φ.Μ.'), fieldType: 'TEXT' },
    ...(!isAfisCyprus
      ? [{ fieldName: 'companyTaxOffice', fieldTitle: t('Δ.Ο.Υ.'), fieldType: 'TEXT' }]
      : []),
    { fieldName: 'imaCode', fieldTitle: t('Αριθμός Η.Μ.Α.'), fieldType: 'TEXT' },
    ...(!isRebattery
      ? [{ fieldName: 'cpGroup.name', fieldTitle: t('Κατηγορία'), fieldType: 'TEXT' }]
      : [{ fieldName: 'category.name', fieldTitle: t('Κατηγορία'), fieldType: 'TEXT' }]),
    { fieldName: 'contactPerson', fieldTitle: t('Υπεύθυνος'), fieldType: 'TEXT' },
    { fieldName: 'notes', fieldTitle: t('Σχόλια'), fieldType: 'TEXT' },
    { fieldName: 'isActive', fieldTitle: t('Ενεργή Εγγραφή'), fieldType: 'TEXT' },
    { fieldName: 'isPubliclyVisibleInMap', fieldTitle: t('Ορατό στον Χάρτη'), fieldType: 'TEXT' },
    { fieldName: 'legacyAppId', fieldTitle: t('Κωδικός ERP'), fieldType: 'TEXT' },
    ...(isFotokiklosi
      ? [
          {
            fieldName: 'parentCollectionpoint.legacyAppId',
            fieldTitle: t('Κωδικός ERP Master'),
            fieldType: 'TEXT',
          },
        ]
      : []),

    { fieldName: 'firstRec', fieldTitle: t('Δήλωση'), fieldType: 'TEXT' },
    { fieldName: 'lastRec', fieldTitle: t('Αλλαγή'), fieldType: 'TEXT' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetQueryExcelExport, { onCompleted: transformData });
    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);
    function transformData(data) {
      const recs = data.getCollectionpoints.data.map((values) => {
        return {
          ...values,
          isActive: !values.isActive ? t('ΟΧΙ') : t('ΝΑΙ'),
          isPubliclyVisibleInMap: !values.isPubliclyVisibleInMap ? t('ΟΧΙ') : t('ΝΑΙ'),
          firstRec: ` ${
            values.firstDate ? format(parseISO(values.firstDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.firstUser}`,
          lastRec: ` ${
            values.lastDate ? format(parseISO(values.lastDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.lastUser}`,
          parentCollectionpoint: {
            ...values.parentCollectionpoint,
            legacyAppId: values.parentCollectionpoint
              ? values.parentCollectionpoint.legacyAppId
              : values.legacyAppId,
          },
        };
      });
      const trsData = {
        getCollectionpoints: { data: recs, recordCount: data?.getCollectionpoints?.recordCount },
      };
      setResult([get, { loading, data: trsData }]);
    }
    return result;
  }
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'export CollectionPoints',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}
